var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 126"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "white",
    stroke: "#83C980"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 8.5,
    cy: 8.5,
    r: 4,
    fill: "#83C980",
    stroke: "#83C980"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegItem);
export default __webpack_public_path__ + "static/media/VegItem.be457609723f1ef1ef5b550839062dd2.svg";
export { ForwardRef as ReactComponent };